import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompanyFinCategoriesModes,
  UniversalFilterCompanyFinCategoriesOnChange,
  UniversalFilterCompanyFinCategoriesValue
} from './UniversalFilterCompanyFinCategories.types';

import { useUniversalFilterCompanyFinCategories } from './hooks/useUniversalFilterCompanyFinCategories';

import { FinCategoriesMultiSelect } from '../../../../../main/finCategories/helpers/FinCategoriesMultiSelect';
import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompanyFinCategoriesProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompanyFinCategoriesValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompanyFinCategoriesOnChange;
}

function UniversalFilterCompanyFinCategories({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompanyFinCategoriesProps) {
  const {
    modeOptions,
    filterState,
    handleModeChange,
    handleCategoryIdsChange
  } = useUniversalFilterCompanyFinCategories({
    filterStateCacheKey,
    filterValue,
    onChange
  });

  return (
    <UniversalFilterTemplate<UniversalFilterCompanyFinCategoriesModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <FinCategoriesMultiSelect
        key={filterState.mode}
        value={filterState.categoryIds || []}
        autoFocus={autoFocus}
        onChange={handleCategoryIdsChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanyFinCategories;
